<template>
    <el-calendar ref="calendar" v-loading="loading">
        <template #date-cell="{data}">
            <div>{{ data.day.split('-').slice(1).join('-') }}</div>
            <div v-if="date_map[data.day]" @click="remove(data.day)">
                    <el-image v-if="date_map[data.day].thumbnail" style="width: 70px" lazy
                            :src="`${$root.cdn_url}/${date_map[data.day].thumbnail}`"></el-image>
                    <el-tag v-if="date_map[data.day].animation" type="success" size="small">动图</el-tag>
            </div>
            <div v-else style="height: 70px" @click="openDialog(data.day)"></div>
        </template>
    </el-calendar>
    <el-dialog v-model="dialog_opened" :before-close="reset" width="80%">
        <el-form ref="form" label-width="100" :model="form">
            <el-form-item label="图片" prop="image" :rules="[{required: true, message: '请选择图片'}]">
<!--              <template v-for="image in form.images">-->
                <div v-if="form.image">
                  <el-image style="width: 160px" :src="`${$root.cdn_url}/${form.image.thumbnail}`"></el-image>
                  <video v-if="form.image.animation" :src="`${$root.cdn_url}/${form.image.animation}`" controls muted
                         style="width: 160px; margin-left: 8px"></video>
                </div>
<!--              </template>-->
            </el-form-item>
        </el-form>
        <div>
            <el-input v-model="query.id" placeholder="ID" style="width: 220px"></el-input>
            <el-button type="success" :loading="loading" @click="fetchImages(1)">查询</el-button>
        </div>
        <el-table :data="image_list" v-loading="loading" style="margin-top: 10px">
            <el-table-column label="ID" prop="id" width="250">
              <template #default="scope">
                <div>{{ scope.row.id }}</div>
                <div style="text-align: center">
                  <a :href="`${$root.cdn_url}/${scope.row.resource}`" target="_blank">查看原图</a>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="缩略图" prop="thumbnail" width="100">
              <template #default="scope">
                <el-image :src="`${$root.cdn_url}/${scope.row.thumbnail}`" lazy style="width: 90px"></el-image>
              </template>
            </el-table-column>
            <el-table-column label="动图" prop="animation" width="180">
              <template #default="scope">
                <video v-if="scope.row.animation" :src="`${$root.cdn_url}/${scope.row.animation}`" controls muted
                       style="width: 150px"></video>
              </template>
            </el-table-column>
            <el-table-column label="上线时间" prop="online_date" width="150"></el-table-column>
            <el-table-column label="操作" width="200">
              <template #default="scope">
                <el-button type="primary" @click="addImage(scope.row)" size="small" :disabled="loading || scope.row.added">
                  {{ scope.row.added ? '已添加' : '添加' }} </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination layout="prev, pager, next" :total="total" @current-change="fetchImages"
                         :page-size="query.limit"></el-pagination>
          <template #footer>
            <el-button type="primary" :loading="loading" @click="reset" text>取消</el-button>
            <el-button type="primary" :loading="loading" @click="submit">确定</el-button>
          </template>
    </el-dialog>
<!--    <router-view :key="routeKey"></router-view>-->
</template>

<script>
import axios from 'ts-axios-new';
import {timestampToDate} from "../libs/utils";
import {ElMessageBox} from 'element-plus'
import {getProduct} from "../libs/app";

export default {
    name: "Daily",
    data() {
        return {
            loading: false, image_list: [], date_map: {}, dialog_opened: false, total: 0, page: 1,
            daily_set: new Set(),
            form: {
                date: '',
                image_id: '',
                image: null,
            },
            query: {
                skip: 0,
                limit: 25,
                module: 2,
                online: false,
                product: getProduct().key,
            },
        }
    },
    methods: {
        init() {
            this.loading = true;
            axios.all([
                axios.get(`/cms/v2/daily`, {params: {product: getProduct().key}}).then(res => {
                    this.daily_set = new Set()
                    res.data.data.imageList.forEach(d => {
                        this.date_map[d.date] = d;
                        this.daily_set.add(d.image_id)
                    });
                }),
                // axios.get(`/cms/v1/image?module=${this.v1 ? 2 : 5}`).then(res => {
                //     this.image_list = res.data.data.imageList;
                // }),
            ]).then(_ => {
                this.loading = false;
            })
        },
        remove(date) {
            const today = timestampToDate(Date.now());
            // if (date <= today)
            //     return
            ElMessageBox.confirm('确定要删除这一天的图片吗？', '提示', {
                cancelButtonText: '取消',
                confirmButtonText: '确定',
                type: 'warning',
            }).then(_ => {
                this.loading = true;
                axios.delete(`/cms/v2/daily/${this.date_map[date].id}`).then(res => {
                    this.loading = false;
                    this.daily_set.delete(this.date_map[date].image_id)
                    this.refreshAdded()
                    delete this.date_map[date];
                });
            }).catch(_ => {
            })
        },
        openDialog(date) {
            this.dialog_opened = true;
            this.$nextTick(_ => {
                this.form.date = date;
            });
            this.fetchImages(1)
        },
        reset() {
            if (this.form.image) {
              this.form.image.added = false
              this.daily_set.delete(this.form.image.id)
            }
            this.$refs.form.resetFields();
            this.loading = this.dialog_opened = false;
            this.form.image_id = null
            this.form.image = null
        },
        submit() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.loading = true;
                    axios.post(`/cms/v2/daily`, this.form).then(res => {
                        this.date_map[res.data.data.date] = res.data.data;
                        this.date_map[res.data.data.date].thumbnail = this.form.image.thumbnail
                        this.date_map[res.data.data.date].animation = this.form.image.animation
                        this.form.image = null
                        this.reset();
                    })
                }
            })
        },
        fetchImages(page) {
          this.query.skip = (page - 1) * this.query.limit;
          this.page = page
          this.loading = true;
          axios.get(`/cms/v1/image`, {params: this.query}).then(res => {
            this.image_list = res.data.data.imageList;
            this.total = res.data.data.total;
            this.loading = false;
            this.refreshAdded();
          })
        },
        refreshAdded() {
          this.image_list.forEach(image => {
            image.added = false;
          });
          this.image_list.forEach(image => {
            image.added = this.daily_set.has(image.id);
          });
        },
        addImage(image) {
          if (this.form.image) {
            this.form.image.added = false
            this.daily_set.remove(this.form.image.id)
          }
          image.added = true
          this.daily_set.add(image.id)
          this.form.image = image
          this.form.image_id = image.id
        },
    },
    mounted() {
        this.init();
    },
    computed: {
        // dataFilter() {
        //     return this.image_list.filter(d => {
        //         for (const date in this.date_map) {
        //             if (d.id === this.date_map[date].image_id) {
        //                 return false;
        //             }
        //         }
        //         return d.module === this.v1 ? 2 : 5;
        //     })
        // },
        // routeKey() {
        //   return this.$route.path;
        // },
    },
    // watch: {
    //   // 监听路由变化
    //   '$route'(to, from) {
    //     if (to.path === '/daily' || to.path === '/daily/v1') {
    //       location.reload()
    //     }
    //   },
    // },
}
</script>

<style scoped>
.el-calendar ::v-deep(.el-calendar-day) {
    height: fit-content;
    width: 160px;
    min-height: var(--el-calendar-cell-width);
}

.el-radio {
    height: fit-content;
    margin: 5px;
}
</style>
